module.exports = __webpack_public_path__ + "static/cg_role_153_00164aece33.wav";